export default "__VITE_ASSET__Wlyxhvgx__"